import React, { useEffect } from "react";

import { connect, useDispatch, useSelector } from "react-redux";

import { LoadingOutlined } from "@ant-design/icons";

import { linkedInTokenInit, isModalVisibleAuth, fetchLinkedInTokenFail } from "../../../redux/actions";

import history from "../../../routes/history"
import { getCookie, setCookie } from "../../../shared/helpers";

const LinkedInCheck = (props) => {

  const dispatch = useDispatch();

  useEffect(() => {
    const currURL = window.location.href;
    const token = currURL.split("=")[1]?.toString()?.split("&");
    if (token) {
      props.sendLinkedToken(token[0]);
    } else {
      window.location.replace("/");
    }
  }, []);


  // So save token directly in saga through setCookie which works
  useEffect(() => {
    const token = props.user.authToken;
    if (token) {
      // history.push("/auth");
      window.location.replace('/employer/auth')
    }
  }, [props.user.authToken]);

  useEffect(() => {
    // checking if the user exist from different social client, redirects to login if true
    if (props.error.existingUser) {
      // alertNotification("error", props.error.message);
      history.push("/");
      dispatch(fetchLinkedInTokenFail({}));
      if (window.innerWidth > 1000) {
        return setTimeout(() => dispatch(isModalVisibleAuth(true)), 2000);
      } else {
        return history.push("/login");
      }
    }
  }, [props.error]);
  // This useEffect take application to loop in between login and auth routes
  // So save token directly in saga through setCookie which works
  // useEffect(() => {
  //   // debugger;
  //   const token = props.user.authToken;
  //   console.log("LinkCheck: ", token);
  //   if (token) {
  //     // setCookie("token", token);
  //     console.log("LinkCheck: ", token);
  //     history.push("/auth");
  //   }
  //   // else {
  //   //   history.push("/login");
  //   // }
  // }, [props.user.authToken]);

  // no need as routes already monitorered
  // useEffect(() => {
  //   const notToken = props.notLogged;
  //   console.log("Nottoken Linkcheck: ", notToken);
  //   if (notToken) {
  //     history.push("/login");
  //   }
  // }, [props.notLogged]);

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          fontSize: "2.5rem",
          margin: "40vh 0",
          color: "#e73959",
        }}
      >
        <LoadingOutlined />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    notLogged: state.authReducer.notLogged,
    error: state.authReducer.error,
    // userProfile: state.profileReducer.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendLinkedToken: (token) => {
      dispatch(linkedInTokenInit(token)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedInCheck);
